import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// routes
import { CURD_L1_MENU_CHR } from "../../../../utils/routes";

// ---------------------------------------------------------------------

export const createL1MenuChr = createAsyncThunk(
  "l1MenuChr/createL1MenuChr",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(CURD_L1_MENU_CHR, data, {
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const getL1MenuChr = createAsyncThunk(
  "l1MenuChr/getL1MenuChr",
  async (obj, {rejectWithValue}) => {
    try {
      const response = await axios.get(CURD_L1_MENU_CHR, { withCredentials: true });
      return response;
    } catch (err) {
      return rejectWithValue(err.response)
    }
  }
);

export const updateL1MenuChr = createAsyncThunk(
  "l1MenuChr/updateL1MenuChr",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put(CURD_L1_MENU_CHR, data, {
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const deleteL1MenuChr = createAsyncThunk(
  "l1MenuChr/deleteL1MenuChr",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.delete(CURD_L1_MENU_CHR, {
        data,
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

const l1MenuChrSlice = createSlice({
  name: "l1MenuChr",
  initialState: {
    loading: false,
    message: "",
    errMessage: "",
    l1MenuData: [],
    l1SelectedData: {},
  },
  reducers: {
    resetMessage: (state) => {
      state.message = "";
    },
    resetErrMessage: (state) => {
      state.errMessage = "";
    },
    rowSelect: (state, action) => {
      state.l1SelectedData = action?.payload.length > 0 && action?.payload[0];
    },
  },
  extraReducers: {
    [createL1MenuChr.pending]: (state, action) => {
      state.loading = true;
    },
    [createL1MenuChr.fulfilled]: (state, action) => {
      state.loading = false;
      state.message = action?.payload?.data?.message;
    },
    [createL1MenuChr.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.message;
    },
    [getL1MenuChr.pending]: (state, action) => {
      state.loading = true;
    },
    [getL1MenuChr.fulfilled]: (state, action) => {
      state.loading = false;
      state.l1MenuData = action?.payload?.data;
    },
    [getL1MenuChr.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.data?.message;
    },
    [updateL1MenuChr.pending]: (state, action) => {
      state.loading = true;
    },
    [updateL1MenuChr.fulfilled]: (state, action) => {
      state.loading = false;
      state.message = action?.payload?.data?.message;
    },
    [updateL1MenuChr.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.message;
    },
    [deleteL1MenuChr.pending]: (state, action) => {
      state.loading = true;
    },
    [deleteL1MenuChr.fulfilled]: (state, action) => {
      state.loading = false;
      state.message = action?.payload?.data?.message;
    },
    [deleteL1MenuChr.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.message;
    },
  },
});

export const { resetMessage, resetErrMessage, rowSelect } =
  l1MenuChrSlice.actions;
export default l1MenuChrSlice.reducer;
